import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import { encryptToken, decryptToken } from '@/utils/tokenStorage';
import { shouldPersistMutation } from './persistence';
import { viewportPlugin } from './viewport';
import app from './modules/app';
import theme from './modules/theme';
import user from './modules/user';
import consult from './modules/consult';
import corban from './modules/corban';
import proposal from './modules/proposal';
import retract from './modules/retract';
import contract from './modules/contract';
import massConsult from './modules/massConsult';
import notifications from './modules/notifications';

Vue.use(Vuex);

const persist = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage,
  filter: shouldPersistMutation,
  reducer: (state) => ({
    retract: state.retract,
    app: state.app,
    consult: state.consult,
    proposal: state.proposal,
    contract: state.contract,
  }),
  // custom (de)serialization so only `app.token` is encrypted at rest —
  // everything else keeps the library's default plain JSON behavior
  saveState: (key, reducedState, storage) => {
    const toPersist = {
      ...reducedState,
      app: reducedState.app && {
        ...reducedState.app,
        token: encryptToken(reducedState.app.token),
      },
    };

    storage.setItem(key, JSON.stringify(toPersist));
  },
  restoreState: (key, storage) => {
    const raw = storage.getItem(key);
    if (typeof raw !== 'string') return {};

    const parsed = JSON.parse(raw || '{}');

    if (parsed.app) {
      parsed.app = { ...parsed.app, token: decryptToken(parsed.app.token) };
    }

    return parsed;
  },
});

export default new Vuex.Store({
  plugins: [persist.plugin, viewportPlugin()],
  modules: {
    app: {
      namespaced: true,
      ...app,
    },
    consult: {
      namespaced: true,
      ...consult,
    },
    theme: {
      namespaced: true,
      ...theme,
    },
    user: {
      namespaced: true,
      ...user,
    },
    proposal: {
      namespaced: true,
      ...proposal,
    },
    corban: {
      namespaced: true,
      ...corban,
    },
    retract: {
      namespaced: true,
      ...retract,
    },
    contract: {
      namespaced: true,
      ...contract,
    },
    massConsult: {
      namespaced: true,
      ...massConsult,
    },
    notifications: {
      namespaced: true,
      ...notifications,
    },
  },
});
